import { callApi } from "@/api/api-core";
import moment from "moment-timezone";

export const fetchInfo = function (ownerHandlesFailure) {
    return callApi(
        "POST",
        "v1/products/controlfee/info",
        {},
        ownerHandlesFailure
    );
};
export const getPriceAndDate = function (
    referenceNumber,
    ownerHandlesFailure
) {

    const requestData = {
        referenceNumber
    };

    return callApi(
        "POST",
        "v1/products/controlfee/get",
        requestData,
        ownerHandlesFailure
    );
};

export const createOrder = function (
    referenceNumber,
    productVariantId,
    ownerHandlesFailure
) {

    const requestData = {
        salesChannelIdentifier: "Webshop",
        productVariantId,
        referenceNumber
    };

    return callApi(
        "POST",
        "v1/products/controlfee/order",
        requestData,
        ownerHandlesFailure
    );
};
